import axios from 'axios';
import Analytics from 'shared/utility/analytics';
import { INIT, NAVIGATE } from '../../shared/wizard/actions';

export const getSettings = (callback) => {
  const payload = {
    providers: false,
    settings: false,
    regulations: false,
    data: {},
  };

  axios({
    method: 'get',
    url: '/hns/mortgage-providers',
  }).then((response) => {
    payload.data = {
      ...payload.data,
      mortgage_providers: response.data,
    };
    payload.providers = true;
    if (payload.settings && payload.regulations) callback(payload);
  }).catch(err => console.error(err));

  axios({
    method: 'get', // todo: change to post once endpoint is implemented
    url: '/hns/regulations',
  }).then((response) => {
    payload.data = { ...payload.data, regulations: response.data };
    payload.regulations = true;
    if (payload.settings && payload.providers) callback(payload);
  }).catch(err => console.error(err));

  axios({
    method: 'post',
    url: '/hns/tool-settings',
  }).then((response) => {
    payload.data = { ...payload.data, ...response.data };
    payload.settings = true;
    const { uaCode } = payload.data;
    Analytics.init('G-5DRR0QM857', uaCode);
    if (payload.providers && payload.regulations) callback(payload);
  }).catch(err => console.error(err));
};

export const startAdvanced = (pages, dispatch, location, navigate) => {
  if (pages.length < 4) {
    dispatch({
      type: INIT,
      location,
      navigate,
      payload: {
        pages: [
          'landing',
          'mortgage',
          'results',
          'income',
          'savings',
          'final',
        ],
      },
    });
  }
  dispatch({
    type: NAVIGATE,
    location,
    navigate,
    delta: 1,
  });
};
